
export function setItems(state, data) {
  state.items = data
}



